import { SelectOptionType } from '@config/type'
import { AgeFilterType, MessangerFilterType } from '@shared/types/filters'

export const ageSelectItems: SelectOptionType<AgeFilterType>[] = [
  { label: '18-25', value: 'from18to25' },
  { label: '25-35', value: 'from25to35' },
  { label: '35-45', value: 'from35to45' },
  { label: '45+', value: 'from45more' }
]

export const ageRangeObject = {
  from18to25: {
    from: 18,
    to: 25
  },
  from25to35: {
    from: 25,
    to: 35
  },
  from35to45: {
    from: 35,
    to: 45
  },
  from45more: {
    from: 45,
    to: null
  }
}

export const databasesSelectItems: SelectOptionType<MessangerFilterType>[] = [
  { label: 'All', value: 'any' },
  { label: 'Telegram', value: 'telegram' },
  { label: 'Email', value: 'email' },
  { label: 'WhatsApp', value: 'whatsapp' }
]
